import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    CategoryProductListContainer as SourceCategoryProductListContainer,
    mapDispatchToProps,
    mapStateToProps,
} from 'SourceComponent/CategoryProductList/CategoryProductList.container';

import './CategoryProductList.override.style.scss';

export { mapStateToProps, mapDispatchToProps };

/** @namespace AdvoxBasic/Component/CategoryProductList/Container/CategoryProductListContainer */
export class CategoryProductListContainer extends SourceCategoryProductListContainer {
    static propTypes = {
        ...super.propTypes,
        renderOnlyPagination: PropTypes.bool,
    };

    static defaultProps = {
        ...super.defaultProps,
        renderOnlyPagination: false,
    };

    containerProps() {
        const {
            filter,
            isPageLoading,
            pages,
            search,
            selectedFilters,
            sort,
            totalItems,
            totalPages,
            renderOnlyPagination,
            isBrandPage,
            brandFilterId,
        } = this.props;

        return {
            filter,
            isPageLoading,
            pages,
            search,
            selectedFilters,
            sort,
            totalItems,
            totalPages,
            renderOnlyPagination,
            isLoading: this.getIsLoading(),
            isPreventRequest: this.getIsPreventRequest(),
            mix: { block: 'CategoryProductList', mods: { layout: this.getLayout() } },
            isBrandPage,
            brandFilterId,
            isInfiniteLoaderEnabled: false,
        };
    }

    requestProductList(options) {
        const { requestProductList, isBrandPage, brandFilterId } = this.props;

        requestProductList({
            ...options,
            isPlp: true,
            noAttributes: !isBrandPage,
            noVariantAttributes: true,
            isBrandPage,
            brandFilterId,
        });
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CategoryProductListContainer);
